<script>
export default {
  name: 'PrivacyJp'
}
</script>

<template lang="pug" src="./PrivacyJp.pug"></template>
<style lang="scss" src="./PrivacyJp.scss" scoped></style>
